import React from "react";
import { motion } from "framer-motion";
import { Building2, ArrowUpRight } from "lucide-react";

export default function PartnerSection() {
  const scrollToContact = () =>
    document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });

  return (
    <section
      id="partenaires"
      className="py-24 lg:py-32 bg-[#0F172A] text-[#FDFBF7] relative overflow-hidden"
      data-testid="partners-section"
    >
      {/* Ambient orange glow */}
      <div className="absolute -top-40 -left-40 w-[600px] h-[600px] rounded-full bg-[#E65100] opacity-[0.12] blur-3xl pointer-events-none" />
      <div className="absolute -bottom-40 -right-40 w-[600px] h-[600px] rounded-full bg-[#2D7A4D] opacity-[0.12] blur-3xl pointer-events-none" />

      <div className="max-w-[1240px] mx-auto px-6 lg:px-10 relative grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        <div className="lg:col-span-6">
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="eyebrow !text-[#FF9800] mb-4"
          >
            Vous êtes un pro ?
          </motion.div>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9 }}
            className="font-serif-display text-[36px] sm:text-[52px] lg:text-[68px] leading-[0.98] tracking-tight balance"
          >
            On vous accompagne aussi.
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, delay: 0.1 }}
            className="mt-6 text-[17px] leading-relaxed text-[#FDFBF7]/75 max-w-xl"
          >
            Rejoignez le réseau de partenaires HMCD et bénéficiez de contrats
            long terme, de financements exclusifs et d'une demande qualifiée.
            Nous vous aidons à gagner plus de chantiers et à sécuriser votre
            chiffre d'affaires.
          </motion.p>
        </div>

        <div className="lg:col-span-6 grid gap-4">
          {[
            {
              id: "solar-partner",
              icon: <Building2 className="h-5 w-5" />,
              title: "Devenir partenaire solaire",
              desc: "Chantiers PV résidentiels & B2B — Île-de-France",
            },
            {
              id: "hvac-partner",
              icon: <Building2 className="h-5 w-5" />,
              title: "Devenir partenaire ITE / chauffage",
              desc: "Rénovation énergétique — enveloppe + PAC",
            },
          ].map((p, i) => (
            <motion.button
              key={p.id}
              onClick={scrollToContact}
              data-testid={`partner-cta-${p.id}`}
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, delay: i * 0.1 }}
              className="group text-left p-6 lg:p-7 rounded-2xl border border-[#FDFBF7]/15 hover:border-[#FF9800] transition-all bg-[#FDFBF7]/[0.02] flex items-center justify-between gap-6"
            >
              <div className="flex items-center gap-5">
                <div className="h-12 w-12 rounded-full bg-[#FF9800] text-[#0F172A] flex items-center justify-center shrink-0">
                  {p.icon}
                </div>
                <div>
                  <div className="font-serif-display text-xl lg:text-2xl">
                    {p.title}
                  </div>
                  <div className="text-sm text-[#FDFBF7]/60 mt-1">{p.desc}</div>
                </div>
              </div>
              <ArrowUpRight className="h-5 w-5 text-[#FF9800] transition-transform group-hover:translate-x-1 group-hover:-translate-y-1 shrink-0" />
            </motion.button>
          ))}
        </div>
      </div>
    </section>
  );
}
